export class ReportDatails {
    FromDate: Date;
    ToDate: Date;
    ZoneID?: number;
    UserID: number;
    DealerID?: number;
    DealerSEID?: number;
    ProductRangeID?: number;
    flag?:number;
    days?:number;
    BusinessLineID: number;
}
